module.exports = __webpack_public_path__ + "assets/791e74fa500bb642cdb51c36b5974c6f.svg";